import { NewsletterId } from 'modules/newsletters/single/types/newsletter-interface'

export const getNewslettersEditorNextjsUrl = (newsletterId: NewsletterId) =>
  `/newsletters/${newsletterId}/edit`
